export default __webpack_public_path__ + "static/media/connected-dots.dcd9bf3c.svg";